"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bridge = void 0;
const constants_1 = require("../constants");
exports.bridge = {
    get api() {
        return window[constants_1.SR_APP_WINDOW_BRIDGE].api;
    },
    get components() {
        return window[constants_1.SR_APP_WINDOW_BRIDGE].components;
    },
    register(params) {
        const { api = {}, components = {} } = params;
        window[constants_1.SR_APP_WINDOW_BRIDGE] = {
            api,
            components
        };
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2JyaWRnZS9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw0Q0FBbUQ7QUFrQnRDLFFBQUEsTUFBTSxHQUFXO0lBQzVCLElBQUksR0FBRztRQUNMLE9BQU8sTUFBTSxDQUFDLGdDQUFvQixDQUFDLENBQUMsR0FBRyxDQUFDO0lBQzFDLENBQUM7SUFFRCxJQUFJLFVBQVU7UUFDWixPQUFPLE1BQU0sQ0FBQyxnQ0FBb0IsQ0FBQyxDQUFDLFVBQVUsQ0FBQztJQUNqRCxDQUFDO0lBRUQsUUFBUSxDQUFDLE1BQU07UUFDYixNQUFNLEVBQUUsR0FBRyxHQUFHLEVBQUUsRUFBRSxVQUFVLEdBQUcsRUFBRSxFQUFDLEdBQUcsTUFBTSxDQUFDO1FBQzVDLE1BQU0sQ0FBQyxnQ0FBb0IsQ0FBQyxHQUFHO1lBQzdCLEdBQUc7WUFDSCxVQUFVO1NBQ1gsQ0FBQTtJQUNILENBQUM7Q0FDRixDQUFBIn0=